<template>
  <div>
    <v-app-bar
      app
      elevation="4"
      class="d-flex justify-center"
      style="background: linear-gradient(180deg, #0071bd 0%, #005187 100%)"
    >
      <v-img src="../../../src/assets/images/whitebodytalklogo.png"></v-img>
    </v-app-bar>
    <div class="d-flex justify-center">
      <v-card max-width="800" flat>
        <v-card>
          <v-img
            src="../../../src/assets/images/forgetpasswordimage.png"
            height="180"
          ></v-img>
        </v-card>
        <v-card class="my-11 py-5 px-9">
          <div class="main-heading d-flex justify-center">
            [Title] Registration for obtaining t-shirts
          </div>
          <div
            class="font-14 d-flex justify-center mt-5"
            style="text-align: center"
          >
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean
            etiam sit mauris mollis venenatis sed faucibus at. Ac diam gravida
            at tortor ac fames in.
          </div>
        </v-card>
        <v-card class="my-11 py-5 px-9">
          <div class="h1">[Question 1] What is your favorite book?</div>
          <v-text-field
            label="Write your anser here"
            single-line
          ></v-text-field>
        </v-card>
        <v-card class="my-11 py-5 px-9">
          <div class="h1">[Question 2] Select your choise</div>

          <div class="d-flex">
            <div>
              <v-checkbox v-model="questioncheckbox" value="Option 1">
                <template v-slot:label>
                  <span class="mt-2 black--text">Option 1</span>
                </template>
              </v-checkbox>
            </div>
            <v-checkbox v-model="questioncheckbox" value="Others" class="mx-9">
              <template v-slot:label>
                <span class="mt-2 black--text">Others</span>
              </template>
            </v-checkbox>
            <v-checkbox v-model="questioncheckbox" value="Others1">
              <template v-slot:label>
                <span class="mt-2 black--text">Others</span>
              </template>
            </v-checkbox>
          </div>
        </v-card>
        <v-btn color="primary" block @click="postQuestion()">SEND</v-btn>
      </v-card>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      questioncheckbox: [],
    };
  },
  methods: {
    postQuestion() {
      this.$swal.fire({
        icon: "success",
        title: '<span style="font-size:20px"> Post successfully</span>',
        confirmButtonColor: "#3085d6",
        showConfirmButton: true,
      });
    },
  },
};
</script>
<style scoped>
.main-heading {
  font-family: "Merriweather";
  font-size: 24px;
  font-weight: 400;
}
.h1 {
  font-family: "Lato";
  font-size: 18px;
  font-weight: 700;
}
.font-14 {
  font-size: 14px;
}
</style>
